import type { Epic } from '../../../index.ts'
import { orderSlice } from '../../../Slice/Order/OrderSlice.ts'
import { catchError, filter, mergeMap, of } from 'rxjs'
import { InviteRepository } from 'Repository/index.ts'

export const InviteLabEpic: Epic = (action$, state$, { [orderSlice.name]: order }) =>
  action$.pipe(
    filter(order.inviteLabRequest.match),
    mergeMap((action) =>
      InviteRepository.inviteLab(action.payload.orderId, action.payload.invite).pipe(
        mergeMap((response) => of(order.inviteLabRequestSuccess({ orderId: action.payload.orderId, invite: response }))),
        catchError((error: Error) => of(order.inviteLabRequestFailure({ error })))
      )
    )
  )
